var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tamanho == null)?_c('div',[_c('img',{attrs:{"src":require("../assets/logo/LOGOS-100x100.png"),"alt":""}})]):_c('div',[_c('img',{attrs:{"src":_vm.getImgUrl(_vm.tamanho),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }